var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customers"},[_c('v-row',{staticClass:"px-2",attrs:{"wrap":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-flex',[_c('CustomerTable',{attrs:{"orderData":_vm.orderData}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }